import { CLAIM_FIELDS } from '@/graphql/fragments/claims';
import { gql } from '@apollo/client';

export const ACCEPT_CLAIM = gql`
    ${CLAIM_FIELDS}
    mutation AcceptClaim(
        $claim_id: uuid!
        $update: claims_set_input!
        $adjustments: [claim_adjustments_insert_input!]!
    ) {
        insert_claim_adjustments(objects: $adjustments) {
            returning {
                ...ClaimAdjustmentFields
            }
        }
        update_claims(where: { claim_id: { _eq: $claim_id } }, _set: $update) {
            returning {
                ...ClaimFields
            }
        }
    }
`;
